import { useEffect } from 'react';
import { ConnectButton, useActiveAccount } from 'thirdweb/react';
import { polygon } from 'thirdweb/chains';
import { client } from '../thirdwebClient';
import './WalletConnect.css';

export default function WalletConnect({ onConnect, onDisconnect }) {
  const account = useActiveAccount();

  useEffect(() => {
    if (account?.address) {
      onConnect?.(account.address);
    } else {
      onDisconnect?.();
    }
  }, [account?.address]);

  return (
    <ConnectButton
      client={client}
      chain={polygon}
      theme="dark"
      connectButton={{
        label: 'Connect Wallet',
        style: {
          background: 'linear-gradient(270deg, #00D4FF, #8B00FF, #FF006E)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 4s ease infinite',
          border: 'none',
          borderRadius: '8px',
          color: '#ffffff',
          fontWeight: '700',
          fontSize: '13px',
          padding: '10px 20px',
          cursor: 'pointer',
          letterSpacing: '0.5px',
        },
      }}
      detailsButton={{
        style: {
          background: '#0f0f1a',
          border: '1px solid #00D4FF',
          borderRadius: '8px',
          color: '#ffffff',
          fontSize: '13px',
          padding: '8px 16px',
          boxShadow: '0 0 15px #00D4FF44',
        },
      }}
      detailsModal={{
        style: {
          background: '#0f0f1a',
          border: '1px solid #00D4FF33',
          borderRadius: '14px',
        },
      }}
    />
  );
}
